<template>
  <transition
    appear
    :appear-class="computedTransitionName + '-appear'"
    :appear-to-class="computedTransitionName + '-appear-to'"
    :appear-active-class="computedTransitionName + '-appear-active'"
    :name="computedTransitionName"
    @before-appear="handleBeforeAppear"
    @before-enter="handleBeforeEnter"
    @after-enter="handleAfterEnter"
    @after-appear="handleAfterAppear"
    @enter-cancelled="handleEnterCancelled"
  >
    <router-view
      ref="router-view"
      @subview-event="handleSubviewEvent"
      class="transition-router-view"
    />
  </transition>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('routing', {
      navigationDirection: 'navigation_direction',
      isRootTransition: 'is_root_transition',
      transitionPromise: 'transition_promise'
    }),
    computedTransitionName() {
      if (this.isRootTransition) {
        return ''
      }
      const direction = this.navigationDirection === 1 ? 'forwards' : 'backwards'
      return `slide-${direction}-`
    }
  },
  methods: {
    handleSubviewEvent(event) {
      this.$emit('subview-event', event)
    },
    handleBeforeEnter() {
      this.$store.dispatch('routing/CREATE_TRANSITION_PROMISE')
    },
    handleAfterEnter() {
      this.$store.dispatch('routing/RESOLVE_TRANSITION_PROMISE')

      this.callPostTransitionHooks()
    },
    handleBeforeAppear() {
      // Leave to avoid firing before-enter on before-appear
    },
    async handleAfterAppear() {
      // Wait for any transitions to complete
      const transitionComplete = this.transitionPromise || Promise.resolve()
      await transitionComplete
      this.callPostTransitionHooks()
    },
    handleEnterCancelled() {
      this.$store.dispatch('routing/REJECT_TRANSITION_PROMISE')
    },
    callPostTransitionHooks() {
      this.$refs['router-view'].afterEnter && this.$refs['router-view'].afterEnter()
    }
  }
}
</script>

<style lang="scss">
.transition-router-view {
  position: relative;
  width: 100%;
}
// Ensure that the entering view is positioned above as long as they are both in the dom at the same time
// NB: The entering view is after the leaving view in the markup order:
// <* class="transition-router-view slide-backwards--leave-active slide-backwards--leave-to" />
// <* class="transition-router-view slide-backwards--enter-active slide-backwards--enter-to" />
.transition-router-view + .transition-router-view {
  position: fixed !important;
  left: 0;
  top: 0;
}

// Slide forwards
.slide-forwards--enter,
.slide-backwards--enter,
.slide-forwards--leave,
.slide-backwards--leave,
.slide-forwards--enter-active,
.slide-backwards--enter-active,
.slide-forwards--leave-active,
.slide-backwards--leave-active {
  will-change: transform;
}
.slide-forwards--enter-active,
.slide-backwards--enter-active,
.slide-forwards--leave-active,
.slide-backwards--leave-active {
  transition: transform 350ms ease;
}
.platform--browser .slide-forwards--enter-active,
.platform--browser .slide-backwards--enter-active,
.platform--browser .slide-forwards--leave-active,
.platform--browser .slide-backwards--leave-active {
  transition-duration: 0ms;
}
.slide-forwards--enter,
.slide-forwards--enter-active {
  box-shadow: 0 0 15px rgba(#000, 0.15);
}
.slide-forwards--enter {
  transform: translate3d(100%, 0, 0);
}
.slide-forwards--enter-to,
.slide-forwards--leave {
  transform: translate3d(0, 0, 0);
}
.slide-forwards--leave-to {
  transform: translate3d(-110px, 0, 0);
}

// Slide backwards
.slide-backwards--enter {
  transform: translate3d(-110px, 0, 0);
}
.slide-backwards--leave,
.slide-backwards--leave-active {
  z-index: 1;
  box-shadow: 0 0 15px rgba(#000, 0.15);
}
.slide-backwards--enter-to,
.slide-backwards--leave {
  transform: translate3d(0, 0, 0);
}
.slide-backwards--leave-to {
  transform: translate3d(100%, 0, 0);
}

// Fade
// .fade-forwards--enter,
// .fade-backwards--enter,
// .fade-forwards--leave,
// .fade-backwards--leave,
// .fade-forwards--enter-active,
// .fade-backwards--enter-active,
// .fade-forwards--leave-active,
// .fade-backwards--leave-active {
//   will-change: opacity;
// }
// .fade-forwards--enter-active,
// .fade-backwards--enter-active {
//   transition: opacity 100ms linear;
// }
// .fade-forwards--leave-active,
// .fade-backwards--leave-active {
//   transition: opacity 0ms linear;
// }
// .fade-forwards--enter,
// .fade-backwards--enter {
//   opacity: 0;
//   transition-delay: 10ms;
// }
// .fade-forwards--leave-to,
// .fade-backwards--leave-to {
//   opacity: 0;
//   // Leaving view is at the bottom, so avoid seeing through it by delaying the transition
//   transition-delay: 100ms + 10ms;
// }
</style>
